// src/App.js
import React, { useState, useEffect } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";
import Login from "./components/Login";
import FamilyTree from "./components/FamilyTree";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // ✅ Listen to Firebase auth state
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-green-500"></div>
      </div>
    );
  }

  // If not signed in, show login
  if (!user) {
    return <Login />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-green-50 to-white">
      {/* Header */}
      <header className="bg-green-600 shadow-md py-4 px-6 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-white tracking-wide">
          THLAH-TU KUNG
        </h1>
        <div className="flex items-center gap-4">
          <span className="text-white hidden sm:inline">
            {user.email}
          </span>
          <button
            onClick={() => signOut(auth)}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg shadow transition-colors"
          >
            Logout
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 p-6">
        <div className="bg-white shadow-lg rounded-2xl p-4 h-full">
          {/* ✅ Pass the logged-in user down to FamilyTree */}
          <FamilyTree user={user} />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-100 text-center py-3 text-sm text-gray-600 border-t">
        © {new Date().getFullYear()} THLAH-TU KUNG | Developed by Dr. VanlalRuata
      </footer>
    </div>
  );
}

export default App;